module.exports = __webpack_public_path__ + "img/loading.4418150f.svg";